'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('@ali/prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

require('./index.styl');

var _log = require('@ali/log');

var _log2 = _interopRequireDefault(_log);

var _get_locale = require('@ali/brokkoli/lib/utils/get_locale');

var _get_locale2 = _interopRequireDefault(_get_locale);

var _broccoliCmpPop = require('@ali/broccoli-cmp-pop');

var _broccoliCmpPop2 = _interopRequireDefault(_broccoliCmpPop);

var _network = require('@ali/network');

var _network2 = _interopRequireDefault(_network);

var _getBgImgOrColor = require('@ali/unit/utils/getBgImgOrColor');

var _getBgImgOrColor2 = _interopRequireDefault(_getBgImgOrColor);

var _getColor = require('@ali/unit/utils/getColor');

var _getColor2 = _interopRequireDefault(_getColor);

var _resource = require('@ali/resource');

var _resource2 = _interopRequireDefault(_resource);

var _simpleUa = require('@ali/simple-ua');

var _simpleUa2 = _interopRequireDefault(_simpleUa);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _require = require('@ali/bucket/components/app_link'),
    callOrDownload = _require.callOrDownload,
    appType = _require.appType,
    isInBlackListFromClient = _require.isInBlackListFromClient;

var pg = 'notuser';
var pop = 'pop_' + pg;

var Index = function (_Component) {
  _inherits(Index, _Component);

  function Index(props) {
    _classCallCheck(this, Index);

    var _this = _possibleConstructorReturn(this, (Index.__proto__ || Object.getPrototypeOf(Index)).call(this, props));

    _this.state = {};
    _this.initBind();
    if (!props.isUser) {
      _log2.default.logVisit(pg);
    }
    return _this;
  }

  _createClass(Index, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setBgImgWidth();
    }
  }, {
    key: 'px2Rem',
    value: function px2Rem(px) {
      return px / 1000 + 'rem';
    }
  }, {
    key: 'setBgImgWidth',
    value: function setBgImgWidth() {
      var _this2 = this;

      var bgImg = this.props.bgImg;

      if (this.isUrl(bgImg)) {
        _resource2.default.loadResource([bgImg], function () {
          var $img = _resource2.default.getResource(bgImg);
          _this2.setState({
            bgImgWidth: _this2.px2Rem($img.width)
          });
        });
      }
    }
  }, {
    key: 'initBind',
    value: function initBind() {
      this.act = this.act.bind(this);
      this.downloadBrowser = this.downloadBrowser.bind(this);
      this.downloadNews = this.downloadNews.bind(this);
    }

    // 交互触发非用户界面展示

  }, {
    key: 'act',
    value: function act() {
      this.setState({ openPop: true });
      _log2.default.logVisit(pop);
    }

    // 某类型(browser or news)如果唤起失败，则下载

  }, {
    key: 'download',
    value: function download(type, url) {
      if (!isInBlackListFromClient() && _simpleUa2.default.pf !== 'UC' && _simpleUa2.default.pf !== 'UCNEWS') {
        callOrDownload({
          appType: type,
          downloadUrl: url
        });
      } else {
        window.open(url);
      }
    }

    // browser唤起 >下载

  }, {
    key: 'downloadBrowser',
    value: function downloadBrowser() {
      var _this3 = this;

      var _props = this.props,
          downloadUcBrowser = _props.downloadUcBrowser,
          downloadApkUcBrowser = _props.downloadApkUcBrowser;

      setTimeout(function () {
        var url = _this3.getDLUrl(_network2.default.query('pf') === '355' ? downloadUcBrowser : downloadApkUcBrowser);
        _this3.download(appType.UC_BROWSER_INTL, url);
      }, 200);
      _log2.default.logClick('download_browser_' + pop, { pg: pop });
    }

    // news唤起 >下载

  }, {
    key: 'downloadNews',
    value: function downloadNews() {
      var _this4 = this;

      var _props2 = this.props,
          downloadUcNews = _props2.downloadUcNews,
          downloadApkUcNews = _props2.downloadApkUcNews;

      setTimeout(function () {
        var url = _this4.getDLUrl(_network2.default.query('pf') === '355' ? downloadUcNews : downloadApkUcNews);
        _this4.download(appType.UC_NEWS_INTL, url);
      }, 200);
      _log2.default.logClick('download_news_' + pop, { pg: pop });
    }

    // 获取下载地址，需求1：单配1条下载；   需求2：根据entry值进行匹配

  }, {
    key: 'getDLUrl',
    value: function getDLUrl(key) {
      var urls = (0, _get_locale2.default)(key);
      var entry = _network2.default.query('entry');
      if (Array.isArray(urls)) {
        if (!entry) return urls[0];
        for (var i = 1; i < urls.length; i++) {
          var uArr = urls[i].split('{#}');
          if (uArr[0] === entry) return uArr[1];
        }
        return urls[0];
      }
      return urls;
    }

    // 校验是否一个正确的 url

  }, {
    key: 'isUrl',
    value: function isUrl(str) {
      if (!str) return false;
      var matcher = /^(?:\w+:)?\/\/([^\s\.]+\.\S{2}|localhost[\:?\d]*)\S*$/;
      return matcher.test(str);
    }

    // 关闭非用户界面

  }, {
    key: 'close',
    value: function close() {
      this.setState({ openPop: false });
      _log2.default.logClick('close_' + pop, { pg: pop });
    }

    // 渲染非用户界面

  }, {
    key: 'renderPop',
    value: function renderPop() {
      var openPop = this.state.openPop;

      if (!openPop) {
        return null;
      }
      var _props3 = this.props,
          width = _props3.width,
          title = _props3.title,
          colorTitle = _props3.colorTitle,
          bgTitle = _props3.bgTitle,
          content = _props3.content,
          bgContent = _props3.bgContent,
          colorContent = _props3.colorContent;

      return _react2.default.createElement(
        _broccoliCmpPop2.default,
        { width: width, title: title, colorTitle: colorTitle, bgTitle: bgTitle, bgContent: bgContent, close: this.close.bind(this) },
        _react2.default.createElement(
          'div',
          { className: 'broccoli-cmp-nonuser-pop' },
          this.renderImg(),
          _react2.default.createElement('div', { className: 'broccoli-cmp-nonuser-desc', dangerouslySetInnerHTML: { __html: (0, _get_locale2.default)(content) }, style: _extends({}, (0, _getColor2.default)(colorContent)) }),
          _react2.default.createElement(
            'div',
            { className: 'broccoli-cmp-nonuser-group' },
            this.renderBrowserBtn(),
            this.renderNewsBtn()
          )
        )
      );
    }

    // 非用户界面的视觉图，根据配置，渲染默认 or 配置指定

  }, {
    key: 'renderImg',
    value: function renderImg() {
      var bgImg = this.props.bgImg;

      var url = this.isUrl((0, _get_locale2.default)(bgImg)) ? (0, _get_locale2.default)(bgImg) : '';
      if (url !== '') {
        return _react2.default.createElement('img', { className: 'broccoli-cmp-nonuser-img', src: url, style: { width: this.state.bgImgWidth } });
      }
      return _react2.default.createElement(
        'div',
        { className: 'broccoli-cmp-nonuser-icon' },
        _react2.default.createElement('em', null),
        _react2.default.createElement('i', null),
        _react2.default.createElement('span', null),
        _react2.default.createElement('ul', null)
      );
    }

    // 根据配置，渲染是否存在 browser 下载按钮

  }, {
    key: 'renderBrowserBtn',
    value: function renderBrowserBtn() {
      var _props4 = this.props,
          browserBtn = _props4.browserBtn,
          color = _props4.color;

      if (browserBtn) {
        return _react2.default.createElement(
          'div',
          { className: 'broccoli-cmp-nonuser-btn', onClick: this.downloadBrowser, style: _extends({}, (0, _getBgImgOrColor2.default)(browserBtn), {
              color: color
            }) },
          _react2.default.createElement('span', { className: 'broccoli-cmp-nonuser-icondl' }),
          'UC Browser'
        );
      }
      return null;
    }

    // 根据配置，渲染是否存在 news 下载按钮

  }, {
    key: 'renderNewsBtn',
    value: function renderNewsBtn() {
      var _props5 = this.props,
          newsBtn = _props5.newsBtn,
          color = _props5.color;

      if (newsBtn) {
        return _react2.default.createElement(
          'div',
          { className: 'broccoli-cmp-nonuser-btn', onClick: this.downloadNews, style: _extends({}, (0, _getBgImgOrColor2.default)(newsBtn), {
              color: color
            }) },
          _react2.default.createElement('span', { className: 'broccoli-cmp-nonuser-icondl' }),
          'UC News'
        );
      }
      return null;
    }
  }, {
    key: 'render',
    value: function render() {
      var isUser = this.props.isUser;
      // 兼容cuttle平台

      if (isUser || window.__CUTTLE_PREVIEW__) return null;
      return _react2.default.createElement(
        'div',
        { className: 'broccoli-cmp-nonuser' },
        _react2.default.createElement('div', { className: 'broccoli-cmp-nonuser-act-mask', onTouchStart: this.act }),
        this.renderPop()
      );
    }
  }]);

  return Index;
}(_react.Component);

Index.propTypes = {
  /**
   * @title 是否用户
   */
  isUser: _propTypes2.default.bool,
  /**
   * @title 弹窗宽度默认500
   */
  width: _propTypes2.default.number,
  /**
   * @title 标题颜色/切图
   */
  bgTitle: _propTypes2.default.string,
  /**
   * @title 按钮icon、文字颜色
   */
  color: _propTypes2.default.hexColorString,
  /**
   * @title browser下载按钮颜色 或 切图，配置空则不显示
   */
  browserBtn: _propTypes2.default.string,
  /**
   * @title news下载按钮颜色 或 切图，配置空则不显示
   */
  newsBtn: _propTypes2.default.string,
  /**
   * @title 弹窗title文案(巴别塔定义的key)
   */
  title: _propTypes2.default.string,
  /**
   * @title 弹窗内容文字颜色设置
   */
  colorContent: _propTypes2.default.string,
  /**
   * @title 弹窗内容背景色、背景图设置，非必填，默认白色背景
   */
  bgContent: _propTypes2.default.string,
  /**
   * @title 弹窗content文案(巴别塔定义的key)
   */
  content: _propTypes2.default.string,
  /**
   * @title 巴别塔定义的下载链接key(第二条链接使用 [entry]{#}[url]规则配置根据entry匹配下载链接)
   */
  downloadUcBrowser: _propTypes2.default.string,
  /**
   * @title 巴别塔定义的下载链接key(第二条链接使用 [entry]{#}[url]规则配置根据entry匹配下载链接)
   */
  downloadUcNews: _propTypes2.default.string,
  /**
   * @title 巴别塔定义的下载链接key(第二条链接使用 [entry]{#}[url]规则配置根据entry匹配下载链接)
   */
  downloadApkUcBrowser: _propTypes2.default.string,
  /**
   * @title 巴别塔定义的下载链接key(第二条链接使用 [entry]{#}[url]规则配置根据entry匹配下载链接)
   */
  downloadApkUcNews: _propTypes2.default.string,
  /**
   * @title 头部图片链接 【UI配置】,可填巴别塔key
   */
  bgImg: _propTypes2.default.string
};
Index.defaultProps = {
  isUser: false,
  width: 580,
  bgTitle: '#9c4ac6',
  color: '#ffffff',
  // bgTitle: 'http://img.ucweb.com/s/uae/g/55/lfk/title.jpg',
  title: 'nonuser.title',
  content: 'nonuser.desc',
  downloadUcBrowser: 'nonuser.link_ucbrowser',
  downloadUcNews: 'nonuser.link_ucnews',
  downloadApkUcBrowser: 'nonuser.apklink_ucbrowser',
  downloadApkUcNews: 'nonuser.apklink_ucnews',
  bgImg: 'nonuser.img'
  // bgImg: '//img.ucweb.com/s/uae/g/55/ipl-star-card/images/uc_logo.png',
};
exports.default = Index;